import moment from 'moment'
import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import useStyles from 'features/xray/style/style'

/** API */
import XrayFilmTypeApi from 'api/setting/treatments/xray-film-type.api'
import xrayApi from 'api/xray.api'

/** UTILS || SLICE */
import { dateTimeToView } from 'utils/date.utils'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import print from 'assets/icon/carlendar/print.svg'
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { icons } from 'constants/images'
import { colors } from 'constants/theme'
import _ from 'lodash'
import IconDropdownButton from 'new-components/buttons/icon-dropdown-button'
import { routeName } from 'routes/routes-name'

import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { Box, Grid, InputAdornment } from '@mui/material'
import * as modalSlice from 'app/slice/modal.slice'
import ListXray from 'component/Xray/ListXray'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import { useDispatch, useSelector } from 'react-redux'

// const permissions = {
//     isCreate: isCreate(),
//     isDelete: isDelete(),
//     isUpdate: isUpdate(),
//     isView: isView()
// }

type XrayType = {
  opd?: boolean | false
  patient?: any
  patientId: string
  vnNumber?: string | null
  onSaveTreatment?: () => void
  isClose?: boolean
}

export default function Xray(props: XrayType) {
  const classes = useStyles()
  const { t } = useTranslation()
  const [xray, setXray] = useState([])
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const permissions = { isCreate: isCreate(), isDelete: isDelete(), isUpdate: isUpdate(), isView: isView() }

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createdAt')
  const [sortType, setSortType] = useState('DESC')
  const [search, setSearch] = useState('')
  const [xrayFilmTypeId, setXrayFilmTypeId] = useState<any>(0)
  const [xrayFilmTypes, setXrayFilmTypes] = useState<any[]>([])
  const [rangeDate, setRangeDate] = useState<string[]>(emptyRangePicker)

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const loadData = async () => {
    let condition: any = {}
    let res
    if (page) condition = { ...condition, page: page }
    if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
    if (search) condition = { ...condition, search: search }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (xrayFilmTypeId) condition = { ...condition, xrayFilmTypeId: xrayFilmTypeId === 0 ? '' : xrayFilmTypeId }
    if (rangeDate) {
      if ((rangeDate[0] !== null || rangeDate[0] !== '') && (rangeDate[1] !== null || rangeDate[1] !== '')) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
    }
    if (props.opd) res = await xrayApi.findXrayPatient(props.patientId, condition)
    else res = await xrayApi.findAll(condition)

    if (res.status === 200) {
      setRowCount(res.headers['x-total'])
      setXray(res.data)
    }
  }

  const loadFilter = async () => {
    const condition: any = {
      page: 1,
      pageLimit: 50,
      sortBy: 'createAt',
      sortType: 'ASC',
      status: 'ACTIVE'

    }

    const res = await XrayFilmTypeApi.findAll(condition)
    if (res.status === 200) setXrayFilmTypes(res.data)

  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  useEffect(() => {
    loadFilter()
  }, [])

  const onDelete = () => {
    if (id) {
      xrayApi.deleteXrayPatient(String(id)).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('XRAY.MESSAGE.SUCCESS.DEL'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('XRAY.ERROR.DEL'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const state: any = location?.state
    const val = {
      data,
      routeName: window.location.pathname,
      text: t('XRAY.PATH.EDIT'),
      isEdit: true,
      patientId: state?.patientId,
      servicePointId: state?.servicePointId
    }
    if (props?.onSaveTreatment) {
      props.onSaveTreatment()
    }
    history.push(routeName.xray + '/history', val)
  }

  const onCreate = () => {
    const state: any = location?.state
    const val = {
      routeName: window.location.pathname,
      vnNumber: props.opd ? props.vnNumber : null,
      text: t('XRAY.PATH.CREATE'),
      isCreate: true,
      patientId: state?.patientId,
      servicePointId: state?.servicePointId
    }

    if (props?.onSaveTreatment) {
      props.onSaveTreatment()
    }

    history.push(routeName.xray + '/create', val)
  }

  const onPrint = (data: any) => {
    const state: any = location?.state
    const val = {
      data,
      routeName: window.location.pathname,
      text: t('XRAY.PATH.PRINT'),
      isPrint: true,
      patientId: state?.patientId,
      servicePointId: state?.servicePointId
    }
    history.push(routeName.xray + '/history', val)
  }

  const handleChangeStatus = (valueXrayFilmTypeId: any) => setXrayFilmTypeId(valueXrayFilmTypeId)

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => setPage(val)

  const handleChangeRowsPerPage = (limit: number) => setPageLimit(limit)

  const isShow = useSelector((state: any) => state.modal.isShow)
  const modal_onPreview = useSelector((state: any) => state.modal.modal_xray)
  useEffect(() => {
    if (!isShow) {
      dispatch(modalSlice.setModal_xray(false))
    }
  }, [isShow])
  const onPreview = (data: any) => {
    const state: any = location?.state
    const currentPath = window.location.pathname
    const val = {
      data,
      routeName: currentPath,
      text: t('XRAY.PATH.PREVIEW'),
      patientId: state?.patientId,
      servicePointId: state?.servicePointId
    }
    history.push(currentPath, val)
    setTimeout(() => {
      dispatch(modalSlice.showModal())
    }, 400)
    dispatch(modalSlice.setModal_xray(true))
  }

  const headCells = [
    { id: 'no', disablePadding: false, label: t('TABLE.NO') },
    { id: 'date', disablePadding: false, label: t('XRAY.TABLE.DATE') },
    { id: 'message', disablePadding: false, labelKey: 'XRAY.TABLE.CN_NUMBER', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'PATIENT_MANAGEMENT.TABLE.CELL.BRANCH_ID', align: 'left', class: 'text-nowrap' },
    { id: 'vn', disablePadding: false, label: 'VN' },
    { id: 'namePatient', disablePadding: false, label: t('XRAY.TABLE.NAME_PATIENT') },
    { id: 'typeXray', disablePadding: false, label: t('XRAY.TABLE.CATEGORY_XRAY') },
    { id: 'numXray', align: 'center', disablePadding: false, label: t('XRAY.TABLE.COUNT_XRAY') },
    { id: 'crateName', align: 'center', disablePadding: false, label: t('XRAY.TABLE.CREATE_NAME') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { patientGalleryId, patientId: xRayPatientId, cnNumber, branchCnNumber, vnNumber, xrayFilmTypeName, patientFullName, xrayImages, countXRay, createdAt, updatedBy, updatedAt } = objData
    const objRenderData = {
      key: patientGalleryId,
      id: xRayPatientId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: createdAt ? dateTimeToView(createdAt) : '-' },
        { option: 'TEXT', align: 'left', label: cnNumber || '-' },
        { option: 'TEXT', align: 'left', label: branchCnNumber || props.patient?.branchCnNumber },
        { option: 'TEXT', align: 'left', label: vnNumber },
        { option: 'TEXT', align: 'left', label: patientFullName || `${props.patient?.firstname} ${props.patient?.lastname}` },
        { option: 'TEXT', align: 'left', label: xrayFilmTypeName },
        { option: 'TEXT', align: 'center', label: countXRay ? countXRay : _.isEmpty(xrayImages) ? 0 : xrayImages.length },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy || '-', updatedAt: updatedAt } },
        {
          option: 'COMPONENT',
          align: 'center',
          component: (
            <IconDropdownButton
              options={[
                {
                  label: t('BUTTON.VIEW'),
                  icon: <VisibilityIcon sx={{ color: `${colors.textPrimary} !important`, fontSize: '18px' }} />,
                  onClick: () => onPreview(objRenderData.obj),
                  disabled: permissions.isView.disabled
                },
                ...(!props.isClose
                  ? [
                    {
                      label: t('XRAY.DROPDOWN.EDIT_XRAY'),
                      icon: <img src={icons.dropdownEdit} alt="" />,
                      onClick: () => onEdit(objRenderData.obj),
                      disabled: permissions.isUpdate.disabled
                    },
                    {
                      label: t('XRAY.DROPDOWN.DEL_XRAY'),
                      icon: <img src={icons.dropdownTrash} alt="" />,
                      onClick: () => handleSubmitModal(Number(objRenderData.key), 'DELETE', objRenderData.obj),
                      disabled: permissions.isDelete.disabled
                    }
                  ]
                  : []),
                {
                  label: t('XRAY.DROPDOWN.PRINT_XRAY'),
                  icon: <img src={print} alt="" />,
                  onClick: () => onPrint(objRenderData.obj)
                }
              ]}
            />
          )
        }
      ]
    }
    return <TableRowCommon {...objRenderData} />
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(dateTimeToView(obj.createdAt))
  }

  return (
    <Box >
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`XRAY.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`XRAY.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { date: name, status: t(`XRAY.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: onDelete, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <HeaderCard text={t('XRAY.TITLE.XRAY_LIST')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('XRAY.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              label={t('XRAY.FORM.CATEGORY_ALL')}
              value={xrayFilmTypeId}
              onChange={(event) => {
                const value = event.target.value
                handleChangeStatus(value)
              }}
              options={[{ value: 0, name: t('XRAY.FORM.ALL') }, ..._.map(xrayFilmTypes, (props: any, i: number) => ({ value: props.xrayFilmTypeId, name: props.xrayFilmTypeName }))]}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <InputSecondNewRangePicker
              value={rangeDate || []}
              inputHeight={40}
              onchange={(val: any) => {
                if (_.isEmpty(val)) setRangeDate(emptyRangePicker)
                else {
                  setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                }
              }}
              allowClear
              onClear={() => setRangeDate(emptyRangePicker)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={6}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <MainButton
                onClick={() => {
                  setPage(1)
                  loadData()
                  loadFilter()
                }}
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }} />
              {!props.isClose && <MainButton
                disabled={permissions.isCreate.disabled}
                type='primary'
                variant='contained'
                title={t('XRAY.BUTTON.CREATE')}
                startIcon={<AddCircleIcon />}
                onClick={() => onCreate()}
              />}
            </Box>
          </Grid>
        </Grid>
        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={xray.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>
      </Box>
      {
        isShow && modal_onPreview ? <ListXray updateSuccess={() => loadData()} /> : <></>
      }
    </Box >
  )
}
